<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-md-5">
                <h2>Pridať nového používateľa</h2>
                <div class="card">
                    <div class="card-body">
                        <UserForm :onSubmit="onSubmit"></UserForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserForm from "./components/UserForm";
import { CREATE_USER, RESET_USER } from "../../../vuex/modules/actions.type";
export default {
    name: "NewUser",
    components: { UserForm },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();

            this.$store
                .dispatch(CREATE_USER)
                .then(data => {
                    if (data.data.id) {
                        this.$router.push({ name: "administration" });
                    }
                })
                .catch(() => {
                    this.$bvToast.toast("Niečo sa pokazilo", {
                        title: "Error",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        solid: true,
                        appendToast: true
                    });
                });
        }
    },
    created() {
        this.$store.dispatch(RESET_USER);
    }
};
</script>

<style scoped></style>
